export default status => {
  if (status === 'Processed') {
    return '#ffe0b1';
  } if (status === 'Not Processed') {
    return '#e2e2e2';
  } return '#e2e2e2';
};
